import { Component } from '@angular/core';
import { StartupService } from './services/start/startup.service';
import { StorageService } from './services/data/storage.service';
import { ActionSheetController, AlertController, ModalController, Platform, ToastController } from '@ionic/angular';

const THEME_KEY = 'stewardThemeEnabled';
const FONT_SCALE_KEY = 'fontScale';
const FONT_SCALE_VALUES: Record<string, number> = { small: 0.85, medium: 1.0, large: 1.15 };

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    private startupService: StartupService,
    private storage: StorageService,
    private platform: Platform,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private actionSheetCtrl: ActionSheetController,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      await this.applyTheme();
      this.prewarmOverlays();
      this.startupService.startLogin();
      this.startupService.init();
    });
  }

  private prewarmOverlays() {
    // Instanziert die Controller einmalig damit Ionic die Custom Elements registriert
    // und der erste echte Aufruf sofort erscheint statt 2-5s zu warten
    Promise.all([
      this.modalCtrl.getTop(),
      this.alertCtrl.getTop(),
      this.toastCtrl.getTop(),
      this.actionSheetCtrl.getTop(),
    ]).catch(() => {});
  }

  private async applyTheme() {
    const stored = await this.storage.getData<boolean>(THEME_KEY);
    const enabled = stored !== false;
    document.body.classList.toggle('theme-steward', enabled);
    const scale = await this.storage.getData<string>(FONT_SCALE_KEY);
    AppComponent.applyFontScaleImmediate(scale ?? 'medium');
  }

  static applyThemeImmediate(enabled: boolean) {
    document.body.classList.toggle('theme-steward', enabled);
  }

  static applyFontScaleImmediate(scale: string) {
    const factor = FONT_SCALE_VALUES[scale] ?? 1.0;
    document.documentElement.style.fontSize = `${factor * 16}px`;
  }
}
